/* eslint-disable react/no-array-index-key */

import { css } from 'styled-components';
import { Spacing16, Spacing24 } from 'autogen/design-tokens/tokens';
import type { PersonalOffersModel } from 'autogen/swagger/all';
import MemberVoucher from 'components/clubMatas/MemberVoucher/MemberVoucher';
import DynamicItemCarousel from 'components/generic/ScrollSnapSlider/components/DynamicItemCarousel';
import useIsMobile from 'hooks/responsive/useIsMobile';
import { breakpoint } from 'variables';

const scrollContainerCss = css`
    && {
        gap: ${({ theme }) => theme.Spacing16};
        padding: 0 ${({ theme }) => theme.Spacing16};
        margin: 0 -${({ theme }) => theme.Spacing16};
        scroll-padding-inline-end: ${({ theme }) => theme.Spacing16};
        scroll-padding-inline-start: ${({ theme }) => theme.Spacing16};

        ${breakpoint.up('768px')} {
            gap: ${({ theme }) => theme.Spacing24};
        }

        ${breakpoint.up('1025px')} {
            scroll-padding-inline-end: 0;
            scroll-padding-inline-start: 0;
            padding: 0;
            margin: 0;
        }
    }
    
`;

export default function PersonalOfferSection({ model: { vouchers } }: { model: PersonalOffersModel }) {
    const isMobile = useIsMobile();

    return (
        <DynamicItemCarousel
            gapSize={isMobile ? Spacing16 : Spacing24}
            items={vouchers}
            scrollContainerCss={scrollContainerCss}
            itemRenderer={(voucher, index) => {
                return <MemberVoucher key={index} model={voucher} />;
            }}
        />
    );
}
